/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_InterviewInputs */

const en_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const de_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview-Vorbereitung`)
};

const fr_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const es_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const it_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const nl_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const pl_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const fi_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const da_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const sv_landing_tab_interview = /** @type {(inputs: Landing_Tab_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

/**
* | output |
* | --- |
* | "Interview prep" |
*
* @param {Landing_Tab_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_interview = /** @type {((inputs?: Landing_Tab_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_interview(inputs)
	if (locale === "fr") return fr_landing_tab_interview(inputs)
	if (locale === "es") return es_landing_tab_interview(inputs)
	if (locale === "it") return it_landing_tab_interview(inputs)
	if (locale === "nl") return nl_landing_tab_interview(inputs)
	if (locale === "pl") return pl_landing_tab_interview(inputs)
	if (locale === "fi") return fi_landing_tab_interview(inputs)
	if (locale === "da") return da_landing_tab_interview(inputs)
	if (locale === "sv") return sv_landing_tab_interview(inputs)
	return en_landing_tab_interview(inputs)
});